import React from 'react';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { Translate } from 'react-localize-redux';
import { withLocalize } from "react-localize-redux";
import BbPopover from "../../common/popover";
import classnames from 'classnames';
import HorizontalScrollControl from '../../layoutItems/horizontalScrollControl';
import OldStyleSection from '../../common/oldStyleSection';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

class RegisteredVehicles extends React.Component {
    state = { dataBrandShort: [], showBrandShort: false, dataCategoryShort: [], showCategoryShort: false }

    shouldComponentUpdate(nextProps, nextState) {
        return true;//this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? "" : <div>{this.renderContent(this.props.data)}</div>);
    }

    renderContent(data) {
        if ((!isNullOrUndefined(data.brand) && data.brand.length > 0 && data.brand.length > 5) && this.state.dataBrandShort.length === 0) {
            var dataEdit = JSON.parse(JSON.stringify(data.brand));
            var dataBrandShort = dataEdit.slice(0, 6);
            dataBrandShort[dataBrandShort.length - 1].description = "other";
            dataEdit.slice(6).map(x => {
                x.data.map(item => {
                    if (item.count)
                        dataBrandShort[dataBrandShort.length - 1].data.find(e => e.year === item.year).count += item.count;
                })
                dataBrandShort[dataBrandShort.length - 1].total += x.total;
            })
            this.setState({ dataBrandShort: dataBrandShort, showBrandShort: true });
        }
        if ((!isNullOrUndefined(data.category) && data.category.length > 0 && data.category.length > 5) && this.state.dataCategoryShort.length === 0) {
            var dataEdit = JSON.parse(JSON.stringify(data.category));
            var dataCategoryShort = dataEdit.slice(0, 6);
            dataCategoryShort[dataCategoryShort.length - 1].description = "other";
            dataEdit.slice(6).map(x => {
                x.data.map(item => {
                    if (item.count)
                        dataCategoryShort[dataCategoryShort.length - 1].data.find(e => e.year === item.year).count += item.count;
                })
                dataCategoryShort[dataCategoryShort.length - 1].total += x.total;
            })
            this.setState({ dataCategoryShort: dataCategoryShort, showCategoryShort: true });
        }
        return (
            <div>
                <OldStyleSection
                    key={"ByStatus"} name={this.props.translate(`Report.RegisteredVehicles.ByStatus`)} hasData={!isNullOrUndefined(data.summary) && data.summary.length > 0 && data.summary[0].total > 0} isBold isOpen
                >
                    <div style={{ paddingTop: ".25em" }}>
                        {(!isNullOrUndefined(data.summary) && data.summary.length > 0 && data.summary[0].total > 0) && <HorizontalScrollControl leftArrowMargin="9em">
                            <OldStyleTableWithHistory id={"table-ByStatus"} fixed={false} classNames={{ "fin-stmt-table-first": true }}
                                tableColumns={data.summary[0].data.length + 2} stripped
                                head={() => this.renderHeaderRow(data.summary, "Status")}
                                actualData={data.summary}
                                actualRow={(r, i) => this.renderDataRow(r, i, "Status")}
                            />
                        </HorizontalScrollControl>}
                    </div>
                </OldStyleSection>
                <OldStyleSection
                    key={"ByCategory"} name={this.props.translate(`Report.RegisteredVehicles.ByCategory`)} hasData={!isNullOrUndefined(data.category) && data.category.length > 0} isBold isOpen
                >
                    <div style={{ paddingTop: ".25em", marginBottom: "1.5em" }}>
                        {(!isNullOrUndefined(data.category) && data.category.length > 0) && <HorizontalScrollControl leftArrowMargin="9em">
                            <OldStyleTableWithHistory id={"table-ByCategory"} fixed={false} classNames={{ "fin-stmt-table-first": true }}
                                tableColumns={data.category[0].data.length + 2} stripped
                                head={() => this.renderHeaderRow(data.category, "Category")}
                                actualData={this.state.showCategoryShort ? this.state.dataCategoryShort : data.category}
                                actualRow={(r, i) => this.renderDataRow(r, i, "Category")}
                                noMargin
                            />
                        </HorizontalScrollControl>}
                        {(!this.state.showCategoryShort && this.state.dataCategoryShort.length > 0) && <a onClick={() => this.setState({ showCategoryShort: !this.state.showCategoryShort })}><Translate id="Report.RegisteredVehicles.HideOther" /></a>}
                    </div>
                </OldStyleSection>
                <OldStyleSection
                    key={"ByBrand"} name={this.props.translate(`Report.RegisteredVehicles.ByBrand`)} hasData={!isNullOrUndefined(data.brand) && data.brand.length > 0} isBold isOpen>
                    <div style={{ paddingTop: ".25em", marginBottom: "1.5em" }}>
                        {(!isNullOrUndefined(data.brand) && data.brand.length > 0) && <HorizontalScrollControl leftArrowMargin="9em">
                            <OldStyleTableWithHistory id={"table-ByBrand"} fixed={false} classNames={{ "fin-stmt-table-first": true }}
                                tableColumns={data.brand[0].data.length + 2} stripped
                                head={() => this.renderHeaderRow(data.brand, "Brand")}
                                actualData={this.state.showBrandShort ? this.state.dataBrandShort : data.brand}
                                actualRow={(r, i) => this.renderDataRow(r, i, "Brand")}
                                noMargin
                            />
                        </HorizontalScrollControl>}
                        {(!this.state.showBrandShort && this.state.dataBrandShort.length > 0) && <a onClick={() => this.setState({ showBrandShort: !this.state.showBrandShort })}><Translate id="Report.RegisteredVehicles.HideOther" /></a>}
                    </div>
                </OldStyleSection>
            </div>
        )
    }

    renderHeaderRow = (data, type) => {
        return (
            <thead>
                <tr>
                    <th className="col-sticky right-shadowed" style={{ left: 0, width: "10em", minWidth: "10em", maxWidth: "10em" }}><Translate id={`Report.RegisteredVehicles.TableColumn.${type}`} /></th>
                    {data[0].data.map((item, i) =>
                        <th key={i} style={{ textAlign: "right" }}>{i === 0 ? `${this.props.translate("Report.RegisteredVehicles.TableColumn.Before")} ${item.year + 1}` : item.year}</th>)}
                    <th style={{ textAlign: "right" }}><Translate id="Report.RegisteredVehicles.TableColumn.Total" /></th>
                </tr>
            </thead>
        );
    }
    renderDataRow = (r, i, type) => {
        return (
            <tr key={i} className={classnames("fin-stmt-row", { "level-1": (type === "Status" && r.description === "Total") })}>
                <td className="col-sticky right-shadowed" style={{ left: 0, width: "10em", minWidth: "10em", maxWidth: "10em" }}>{this.getFirstColumn(r, type)}</td>
                {r.data.map((item, ii) => <td key={ii} style={{ textAlign: "right" }}>{item.count}</td>)}
                <td style={{ textAlign: "right" }}>{r.total}</td>
            </tr>
        );
    }

    getFirstColumn = (r, type) => {
        if (r.description === "other")
            return <a onClick={() => { type === "Category" ? this.setState({ showCategoryShort: !this.state.showCategoryShort }) : this.setState({ showBrandShort: !this.state.showBrandShort }) }}><Translate id="Report.RegisteredVehicles.Other" /></a>
        switch (type) {
            case "Category": return <BbPopover
                content={r.description}
                placement="top"
                targetId={`registered-vehicles-category-${r.category}`}
                toggleOnEvent="toggleOnMouse">

                <span id={`registered-vehicles-category-${r.category}`} style={{ display: 'flex', justifyContent: 'left' }}>
                    {r.category}
                </span>
            </BbPopover>;
            case "Status": return this.props.translate(`Report.RegisteredVehicles.ByStatus.${r.description}`);
            default: return r.description
        }
    }
}

export default withLocalize(RegisteredVehicles);
